import React, { useState, useEffect } from 'react';
import { getRecipes, aiSearch } from '@recipe/shared';
import RecipeCard from '../components/RecipeCard';
import { Search, Loader2 } from 'lucide-react';
import CategorySelect from '../components/CategorySelect';
import toast from 'react-hot-toast';
import './Home.css';

const Home = () => {
  const [recipes, setRecipes] = useState([]);
  const [filteredRecipes, setFilteredRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [matchedIds, setMatchedIds] = useState(null);

  const fetchRecipes = async () => {
    try {
      const data = await getRecipes();
      setRecipes(data);
    } catch (error) {
      console.error("Error fetching recipes: ", error);
      toast.error('加载食谱失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecipes();
  }, []);

  useEffect(() => {
    filterRecipes();
  }, [recipes, searchTerm, selectedCategory, matchedIds]);

  const filterRecipes = () => {
    let filtered = recipes;

    if (searchTerm) {
      if (matchedIds) {
        filtered = filtered.filter(r => matchedIds.includes(r.id));
      } else {
        filtered = filtered.filter(recipe => {
          const searchLower = searchTerm.toLowerCase();

          // Search in title and description
          const titleMatch = recipe.title?.toLowerCase().includes(searchLower);
          const descriptionMatch = recipe.description?.toLowerCase().includes(searchLower);

          // Search in part names
          const partNamesMatch = recipe.parts?.some(part =>
            part.name?.toLowerCase().includes(searchLower)
          ) || false;

          return titleMatch || descriptionMatch || partNamesMatch;
        });
      }
    }

    if (selectedCategory) {
      filtered = filtered.filter(recipe =>
        recipe.category === selectedCategory
      );
    }

    setFilteredRecipes(filtered);
  };

  const handleSearchSubmit = async () => {
    if (!searchTerm.trim()) return;
    setIsSearching(true);
    try {
      const ids = await aiSearch(searchTerm, recipes);
      setMatchedIds(ids);
    } catch (e) {
      console.error('Semantic search failed', e);
    } finally {
      setIsSearching(false);
    }
  };

  const existingCategories = [...new Set(recipes.map(recipe => recipe.category).filter(Boolean))];

  if (loading) {
    return (
      <div className="container">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>正在加载食谱...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="home-header">
      </div>

      <div className="search-filter-section">
        <div className="search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="搜食谱 (支持自然语言如：减脂菜)..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              if (!e.target.value) setMatchedIds(null);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchSubmit();
              }
            }}
            className="search-input"
          />
          {isSearching && <Loader2 size={18} className="spin" />}
        </div>

        <div className="filter-box">
          <CategorySelect
            value={selectedCategory}
            onChange={setSelectedCategory}
            categories={existingCategories}
            placeholder="所有分类"
          />
        </div>
      </div>

      {filteredRecipes.length === 0 ? (
        <div className="no-recipes">
          <h3>未找到食谱</h3>
          <p>
            {searchTerm || selectedCategory
              ? '请尝试调整搜索或筛选条件'
              : '成为第一个添加食谱的人！'
            }
          </p>
        </div>
      ) : (
        <div className="recipes-grid">
          {filteredRecipes.map(recipe => (
            <RecipeCard key={recipe.id} recipe={recipe} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Home;
